import { render, staticRenderFns } from "./HojaDiagnostico.vue?vue&type=template&id=3c3aa41d&scoped=true"
import script from "./HojaDiagnostico.vue?vue&type=script&lang=js"
export * from "./HojaDiagnostico.vue?vue&type=script&lang=js"
import style0 from "./HojaDiagnostico.vue?vue&type=style&index=0&id=3c3aa41d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c3aa41d",
  null
  
)

export default component.exports